/*
 * @Author: Wang Bingjing
 * @Date: 2021-03-01 17:34:26
 * @LastEditTime: 2021-06-17 15:16:13
 * @LastEditors: zhengfan
 */
import React, { createContext, useReducer } from 'react';

export const OverallContext = createContext({})

export const SET_SELECTED_SELLER = 'SET_SELECTED_SELLER';

const initState = {
    selectedSeller: '',
    role:''
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case SET_SELECTED_SELLER:
            const newState = { ...state }
            newState.selectedSeller = action.payload.selectedSeller
            newState.role = action.payload.role || state.role
            return newState
        default:
            return state
    }
}

export const OverallProvider = props => {
    const [overallInfo, dispatch] = useReducer(reducer, initState)
    return (
        <OverallContext.Provider value={{ overallInfo, dispatch }}>
            {props.children}
        </OverallContext.Provider>
    )
}

